import type { TpaCompData } from '@wix/thunderbolt-symbols'
import type { ITpaContextMapping } from 'feature-tpa-commons'

export const registerTpasForContext = (
	widgets: { [compId: string]: TpaCompData },
	tpaContextMapping: ITpaContextMapping,
	contextId: string,
	pageId: string
) => {
	const tpaWidgetsToRegister = Object.entries(widgets).map(([id, tpaCompData]) => {
		if (tpaCompData.templateId && id !== tpaCompData.templateId) {
			tpaContextMapping.registerTpaTemplateId(tpaCompData.templateId, id)
		}
		return id
	})

	tpaContextMapping.registerTpasForContext({ contextId, pageId }, tpaWidgetsToRegister)
}
